import pauseSVG from '../assets/img/pause.svg';

window.VAE = window.VAE || {};

VAE.Motion = (function () {
  'use strict';

  let subscriptionActive = false;
  let controlSetters = {}; // Store UI control setters

  function initStateManager() {
    if (subscriptionActive) return;

    console.log('VAE.Motion: Initializing state manager integration');

    if (typeof VAE.StateManager === 'undefined') {
      console.error('VAE.Motion: StateManager not available yet, will retry');
      setTimeout(initStateManager, 100);
      return;
    }

    console.log('VAE.Motion: Subscribing to state changes');

    VAE.StateManager.subscribe('motion', handleStateUpdate);
    subscriptionActive = true;
  }

  function handleStateUpdate(motionState) {
    if (!motionState) {
      console.error(
        'VAE.Motion: Received empty state update from StateManager'
      );
      return;
    }

    console.log(
      'VAE.Motion: Received state update from StateManager',
      motionState
    );

    // Default-Werte für Motion
    const DEFAULT_VALUES = {
      animationsDisabled: false
    };

    // Nur anwenden wenn Werte von Default abweichen
    if (motionState.hasOwnProperty('animationsDisabled') &&
        motionState.animationsDisabled !== DEFAULT_VALUES.animationsDisabled) {
      applyAnimationSettingVisuals(motionState.animationsDisabled);
    }

    // UI Controls immer updaten
    if (controlSetters.animationsDisabled) {
      controlSetters.animationsDisabled(motionState.animationsDisabled);
    }
  }

  function applyAnimationSettingVisuals(isDisabled) {
    const rootElement = document.documentElement;

    if (isDisabled) {
      rootElement.classList.add('vae-disable-animations');
      console.log('VAE.Motion: Animations disabled');
    } else {
      rootElement.classList.remove('vae-disable-animations');
      console.log('VAE.Motion: Animations enabled');
    }
  }

  function triggerStateUpdate(isDisabled) {
    VAE.StateManager.updateState('motion', { animationsDisabled: isDisabled });
  }

  function renderSectionContent(container) {
    container.innerHTML = '';
    controlSetters = {}; // Reset setters when rendering

    try {
      const currentState = VAE.StateManager.getState('motion');
      console.log(
        'VAE.Motion: Rendering tab content with state:',
        currentState
      );

      const disableAnimationsToggle = VAE.SharedUI.createSwitchToggle({
        label: 'Animationen deaktivieren',
        icon: pauseSVG,
        id: 'vae-motion-disable-animations',
        initialChecked: currentState?.animationsDisabled || false,
        onChange: (isChecked) => {
          triggerStateUpdate(isChecked);
        },
      });

      controlSetters.animationsDisabled = disableAnimationsToggle.setValue;
      container.appendChild(disableAnimationsToggle.container);
    } catch (e) {
      console.error('VAE.Motion: Error rendering tab content:', e);
      container.appendChild(
        document.createTextNode(
          'Error loading motion settings. Please try refreshing the page.'
        )
      );
    }
  }

  function getCurrentState() {
    try {
      const stateManagerValues = VAE.StateManager.getState('motion');
      if (stateManagerValues) {
        return { ...stateManagerValues };
      }

      return {
        animationsDisabled: false,
      };
    } catch (e) {
      console.error('VAE.Motion: Error getting current state:', e);
      return {
        animationsDisabled: false,
      };
    }
  }

  function _init() {
    console.log('VAE.Motion: Initializing module');

    function checkStateManager() {
      if (typeof VAE.StateManager !== 'undefined') {
        console.log('VAE.Motion: State manager found, initializing connection');
        initStateManager();
      } else {
        console.log('VAE.Motion: Waiting for state manager');
        setTimeout(checkStateManager, 50);
      }
    }

    checkStateManager();

    console.log('VAE.Motion: Module initialization setup complete');
    return true;
  }

  _init();

  return {
    renderSectionContent,
    getCurrentState,
  };
})();
